import { USER_ROLE_VALUE } from '@socialive/common';
import { Pathnames } from './helpers/enums';
import verifyPath from './helpers/verifyPath';
import { API_BASE_URL } from './store/env/initialState';

/* eslint-disable no-bitwise */
function getOutputFlags(destinations) {
  const vals = {
    facebook: 1,
    youtube: 1 << 1,
    twitter: 1 << 2,
    periscope: 1 << 3,
    twitch: 1 << 4,
    brightcove: 1 << 5,
  };
  const destinationFlags = {};

  Object.keys(vals).forEach((item) => {
    destinationFlags[item] = (destinations & vals[item]) > 0;
  });

  return destinationFlags;
}
/* eslint-enable no-bitwise */

export const getBroadcasts = (accountId, accountRole, APIBaseURL, reAuth, trackEvent, userId) => {
  let filterString = `user.id!=${userId};guests.user.id`;

  if (USER_ROLE_VALUE[accountRole] >= USER_ROLE_VALUE.CREATOR) {
    const joinPage = verifyPath(Pathnames.JOIN) ? '!=' : '==';
    filterString = `user.id${joinPage}${userId};guests.user.id`;
  }

  const URL = `${APIBaseURL}/search/broadcasts?q=${filterString}=in=(${userId});endedAt=lt=1;deletedAt=lt=1&accountId=${accountId}&size=249&sort=createdAt,desc`;
  const params = {
    headers: { authorization: sessionStorage.getItem('authToken') },
  };

  return fetch(URL, params)
    .then((response) => {
      if (response.status === 401) {
        const message = 'Received 401 response from broadcasts API. Redirecting to login.';
        trackEvent('401', { source: 'GET broadcasts API call' });
        reAuth(document.location.pathname, encodeURIComponent(document.location.search));
        throw new Error(message);
      } else {
        return response.json();
      }
    })
    .then((data) => {
      if (data.content.length <= 0) {
        return null;
      }
      return data.content.map((broadcast) => {
        const outputFlags = getOutputFlags(broadcast.destinations);
        return {
          ...broadcast,
          outputFlags,
          comments: outputFlags.facebook,
          selfId: broadcast.id,
        };
      });
    })
    .then((broadcastList) => {
      const broadcastsAvailable = broadcastList && broadcastList.length > 0;
      return {
        list: broadcastsAvailable ? broadcastList : [],
        loading: false,
        error: false,
        noBroadcasts: !broadcastsAvailable,
      };
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Broadcasts API call failed. ', error);
      return {
        list: [],
        loading: false,
        error: true,
        noBroadcasts: false,
      };
    });
};

export const getChannels = (accountId, APIBaseURL, dynamicallySort, reAuth) => {
  if (accountId === undefined || accountId === null) {
    return;
  }

  const params = {
    headers: {
      authorization: sessionStorage.getItem('authToken'),
      'X-API-VERSION': '2.0',
    },
  };

  // eslint-disable-next-line consistent-return
  return fetch(`${APIBaseURL}/remoteStreams/search/findByAccountId?accountID=${accountId}&size=250`, params)
    .then((response) => {
      if (response.status === 401) {
        const message = 'Received 401 response from getChannels. Redirecting to login.';
        reAuth(window.location.pathname, encodeURIComponent(window.location.search));
        throw new Error(message);
      } else {
        return response.json();
      }
    })
    .then((data) => {
      // eslint-disable-next-line no-underscore-dangle
      if (data._embedded.remoteStreams && data._embedded.remoteStreams.length > 0) {
        // eslint-disable-next-line no-underscore-dangle
        return data._embedded.remoteStreams.sort(dynamicallySort('name'));
      }
      return [];
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('remoteStreams API call failed. ', error);
      return [];
    });
};

export const getExchangeToken = async () => {
  const params = {
    method: 'GET',
    headers: {
      authorization: sessionStorage.getItem('authToken'),
      'Content-Type': 'application/json',
    },
  };

  return fetch(`${API_BASE_URL}/auth/exchange`, params)
    .then((response) => response.text())
    .then((result) => JSON.parse(result)?.exchangeToken)
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('auth exchange API call failed. ', error);
    });
};
